import { Stack } from '@mui/material';
import UserAvatar from '../../../../common/UserAvatar';
import { Typography } from '@mui/material';
import { variants } from '../../../../variants/variants';
import { useSelector } from 'react-redux';
import { selectJuryDetails } from '../../giftSlice';
import { FormControl } from '@mui/material';
import { FormLabel } from '@mui/material';
import { Box } from '@mui/material';
import { useTheme } from '@emotion/react';

const JuryDetails = () => {
  const jury = useSelector(selectJuryDetails);
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        border: 0,
        display: 'flex',
        alignItems: 'flex-end',
        // [theme.breakpoints.up('md')]: {
        //   display: 'none',
        // },
      }}
    >
      <FormControl
        component='fieldset'
        sx={{
          width: 1,
          borderRadius: variants.boxRadius.MAIN,
          border: 1,
          borderColor: 'divider',
          p: 1,
        }}
      >
        <FormLabel
          component='legend'
          sx={{
            color: '#229A16',
          }}
        >
          <Typography sx={{ fontSize: variants.BODY }}>Jury panel</Typography>
        </FormLabel>
        <div className='content'>
          {jury?.map((member, index) => {
            return (
              <Stack direction={'row'} key={index} alignItems={'center'} sx={{ mb: 1 }}>
                <UserAvatar src={member.employeePhotoPath} sx={{ width: 30, height: 30 }} />
                <Typography sx={{ fontSize: variants.TINY, ml: 1 }}>{member.empName}</Typography>
              </Stack>
            );
          })}
        </div>
      </FormControl>
    </Box>
  );
};

export default JuryDetails;
